<template>
    <b-card class="h-100">
        <b-card-body v-if="progressLoaded">
            <b-card-header>
                <b-card-title>
                    <font-awesome-icon
                            :icon="['fas', 'tasks-alt']"
                            size="sm"
                    ></font-awesome-icon>
                    &nbsp;{{data.title}}
                </b-card-title>
            </b-card-header>
            <b-card-text>
                <b-row v-for="item in chartData.datasets">
                    <b-col>
                        <h4>{{item.value}}</h4>
                        <h6>{{item.label}}<span class="float-right">{{item.percentage}}%</span></h6>
                        <b-progress class="mb-3" :max="data.max">
                            <b-progress-bar :value="item.percentage"></b-progress-bar>
                        </b-progress>
                    </b-col>
                </b-row>
            </b-card-text>

        </b-card-body>
        <vue-element-loading :active="!progressLoaded" :is-full-screen="false"/>
    </b-card>
</template>

<script>
import Report from '@/services/Report/Report';
import PropertyAssessmentType from '@/services/Property/PropertyAssessmentType';

export default {
  name: 'ActionProgressWidget',
  created() {
    this.getData();
  },
  data() {
    return {
      loading: false,
      data: {
        max: 100,
        loaded: false,
        title: 'Action Progress',
        key: [],
        labels: [],
        type: 'status',
        datasets: [
            {
              title: 'Combined',
              label: 'Actions completed in total',
              riskProfile: 'combined',
              chartData: [],
              loading: false,
            },
            {
              title: 'Level 1',
              label: 'Actions completed for Level 1',
              riskProfile: 'high',
              chartData: [],
              loading: false,
            },
            {
              title: 'Level 2',
              label: 'Actions completed for Level 2',
              riskProfile: 'medium',
              chartData: [],
              loading: false,
            },
            {
              title: 'Level 3',
              label: 'Actions completed for Level 3',
              riskProfile: 'low',
              chartData: [],
              loading: false,
            },
        ],
      },
      chartData: {
        loaded: false,
        datasets: [],
      },
    };
  },
  computed: {
    progressLoaded() {
      return this.chartData.loaded;
    },
  },
  methods: {
    async getData() {
      try {
        await this.getProgressDatasets();
        this.formatProgressChartData();
        this.data.loaded = true;
      } catch (e) {

      }

    },
    getProgressDatasets() {
      return new Promise((resolve, reject) => {
        const requests = this.data;

        requests.datasets.forEach(async ({ riskProfile }, index) => {
          requests.datasets[index].loading = true;
          try {
            // for now, we hardcode FIRE as we only want to get these results
            const assessmentTypeId = PropertyAssessmentType.COMPLIANCE_TYPE_FIRE_ID();

            const { data } = await Report.get(requests.type, riskProfile, assessmentTypeId);

            requests.datasets[index].chartData = data;

          } catch (e) {
            reject(e);
          } finally {
            requests.datasets[index].loading = false;

            // Check to see if all requests are loaded
            let allLoaded = !requests.datasets.map(row => row.loading).includes(true);
            if (allLoaded) {
              resolve(requests);
            }
          }
        });
      });
    },
    formatProgressChartData() {

      const { datasets } = this.data;

      const chartData = [];

      datasets.forEach((item, index) => {
        let { series } = item.chartData.data;
        let totalCounts = series.data.map(row => row.count);

        let completedCounts = series.data.map(row => {
          return (row.label === 'completed') ? row.count : 0;
        });

        let total = totalCounts.reduce((total, number) => total + number);

        let completed = (total > 0) ? completedCounts.reduce((total, number) => total + number) : 0;

        let completedPercentage = (total > 0) ? Math.round((completed / total) * 100) : 0;

        chartData.push({
          label: item.label,
          //value: 50,
          value: completed,
          percentage: completedPercentage
        });
      });

      this.chartData = {
        loaded: true,
        datasets: chartData,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
    .progress {
        height: 0.5rem;
        .progress-bar {
            background-color: #00C853;
        }
    }
    h4 {
        font-weight: bold;
    }
    h6 {
        color: #333333;
        span {
            color: #24415E;
            font-weight: 700;
        }
    }
</style>
